import { format } from 'date-fns/format';
import { Locale, localeToDateFnsLocale } from '../locale';

export const dateToShortLocale = (date: Date, locale: Locale): string => {
  return format(date, 'EEE d MMM, H:mm', { locale: localeToDateFnsLocale(locale) });
};
